export default __webpack_public_path__ + "static/media/tigerking-.0aa2098b.jpg";